export const statusResolver = {
  NOVO_PEDIDO: 'new-orders',
  PREVISTO: 'estimated',
  CRIADO: 'new-orders-criado',
  INCLUIDO: 'new-orders-incluido',
  VISUALIZADO: 'new-orders-visualizado',
  EDITADO: 'edited',
  EM_SEPARACAO: 'picking',
  EM_EDICAO: 'in-edition',
  PRONTO_PARA_SAIR: 'ready-to-go',
  SAIU_PARA_ENTREGA: 'shipping',
  RETORNAR_PARA_ESTOQUE: 'returning-to-storage',
  CANCELADO: 'canceled',
  CANCELADO_PELA_LOJA: 'canceled-from-store',
  FINALIZADO: 'concluded',
  DEVOLVIDO: 'returned',
  PAGO: 'paid',
  NF_EMITIDA: 'invoice',
  RECUSADO: 'recused',
  RETIRADO: 'withdrawn',
  ENTREGUE: 'delivered',
  ALTERACAO_CONFIRMADA: 'confirmed-change',
  PENDENCIA: 'pendency',
  SEM_PENDENCIA: 'without-pendency'
};

export const statusToPage = {
  NOVO_PEDIDO: 'new-orders',
  PREVISTO: 'estimated',
  EM_SEPARACAO: 'picking',
  EDITADO: 'picking',
  PRONTO_PARA_SAIR: 'ready-to-go',
  SAIU_PARA_ENTREGA: 'shipping',
  RETORNAR_PARA_ESTOQUE: 'returning-to-storage',
  CANCELADO: 'history',
  FINALIZADO: 'history',
  DEVOLVIDO: 'history',
  RECUSADO: 'history'
};

export const STATUS = {
  NOVO_PEDIDO: 'NOVO_PEDIDO',
  PREVISTO: 'PREVISTO',
  CRIADO: 'CRIADO',
  INCLUIDO: 'INCLUIDO',
  VISUALIZADO: 'VISUALIZADO',
  EDITADO: 'EDITADO',
  EM_SEPARACAO: 'EM_SEPARACAO',
  EM_EDICAO: 'EM_EDICAO',
  PRONTO_PARA_SAIR: 'PRONTO_PARA_SAIR',
  SAIU_PARA_ENTREGA: 'SAIU_PARA_ENTREGA',
  RETORNAR_PARA_ESTOQUE: 'RETORNAR_PARA_ESTOQUE',
  PAGO: 'PAGO',
  NF_EMITIDA: 'NF_EMITIDA',
  CANCELADO: 'CANCELADO',
  CANCELADO_PELA_LOJA: 'CANCELADO_PELA_LOJA',
  FINALIZADO: 'FINALIZADO',
  DEVOLVIDO: 'DEVOLVIDO',
  RECUSADO: 'RECUSADO',
  RETIRADO: 'RETIRADO',
  ENTREGUE: 'ENTREGUE',
  ALTERACAO_CONFIRMADA: 'ALTERACAO_CONFIRMADA'
};